import { Currency } from './currency'

export type ForExRateResult = {
  multiplier: number
  rateFound: boolean
}

export type ForExRateFn = (base: Currency | string, counter: Currency | string) => ForExRateResult

export function makeForExRateFn(
  fxRates: Array<{ currencyPair: string; spotRate: number }>
): ForExRateFn {
  const rateMap = new Map()
  if (Array.isArray(fxRates)) {
    fxRates.forEach(({ currencyPair, spotRate }) => {
      rateMap.set(`${currencyPair}`, spotRate)
    })
  }

  return (base, counter): ForExRateResult => {
    if (base === counter) {
      return { multiplier: 1, rateFound: true }
    }
    if (rateMap.has(`${base}/${counter}`)) {
      return { multiplier: rateMap.get(`${base}/${counter}`), rateFound: true }
    }
    if (rateMap.has(`${counter}/${base}`)) {
      return { multiplier: 1 / rateMap.get(`${counter}/${base}`), rateFound: true }
    }
    return { multiplier: 1, rateFound: false }
  }
}
